import script from "./LinkTileInternal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LinkTileInternal.vue?vue&type=script&setup=true&lang=ts"

import "./LinkTileInternal.vue?vue&type=style&index=0&id=1c7d5b07&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7d5b07"]])

export default __exports__